const compactNumberFormatter = new Intl.NumberFormat('en', {
  notation: 'compact',
  compactDisplay: 'short',
});

export const formatNumberCompact = (value: string | number) => {
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  return compactNumberFormatter.format(numValue);
};
